// @flow
import { lazy } from 'react';
import Auth from '../../hoc/Auth';

const browseMachinesPromise = import('./BrowseMachines');
export default Auth(lazy(() => browseMachinesPromise));
